import React, { useEffect, useState, useRef } from 'react'
import VerifiedStats, { VerifiedStatsRef } from '../Csr/VerifiedStats'
import { ClientService } from '../../component/services/client.service'
import toast from 'react-hot-toast'
import Select from "react-select"
import moment from 'moment'
import { Button, Card, Col, Form, Row } from 'react-bootstrap'
import CsrStatsIndex, { CsrStatsIndexRef } from '../Csr/CsrStats.index'
import AvarageTimingStats from './AvarageTimingStats'
import VerificationTrends from './VerificationTrends'
import FiltersComponent, { FilterOption } from '../../component/Filters/FiltersComponent'
import StateStats, { IStateStatsRef } from './StateStats'
import { useTheme } from '../../theme/useTheme'

export default function Dashboard() {
    const { colors, colorSchemes } = useTheme()

    const [selectedValue, setSelectedValue] = useState<any>()
    const [shifts, setShifts] = useState<any>()
    const [districts, setDistricts] = useState<any>();
    const [states, setStates] = useState<any>();

    // Create ref for CsrStatsIndex
    const csrStatsRef = useRef<CsrStatsIndexRef>(null);
    const verificationDataRef = useRef<VerifiedStatsRef>(null);
    const stateStatsRef = useRef<IStateStatsRef>(null);

    const [selectedFilters, setSelectedFilters] = useState<{
        states: FilterOption[];
        zones: FilterOption[];
        districts: FilterOption[];
        centers: FilterOption[];
        courses?: FilterOption[];
    }>({
        states: [],
        zones: [],
        districts: [],
        centers: [],
        courses: []
    });

    const handleFiltersChange = (filters: any) => {
        setSelectedFilters(filters);
    };

    const getUniqueCity = async () => {
        if (!selectedValue) return;

        try {
            const params = new URLSearchParams();
            selectedFilters?.zones.forEach((zone) => params.append("zone[]", zone.value));
            selectedFilters?.states.forEach((state) => params.append("state[]", state.value));

            const res = await ClientService.getCities(selectedValue, "?" + params.toString());
            if (res.status === 200) {
                setDistricts(res.data?.districts?.map((zone: any) => ({
                    value: zone,
                    label: zone
                })));
            }
        } catch (err: any) {
            toast.error(err.response?.data || 'Failed to fetch cities');
        }
    };


    const getUniqueState = async () => {
        if (!selectedValue) return;

        try {
            const params = new URLSearchParams();

            const res = await ClientService.getStates(selectedValue, "?" + params.toString());
            if (res.status === 200) {
                setStates(res.data.states?.map((zone: any) => ({
                    value: zone,
                    label: zone
                })));
            }
        } catch (err: any) {
            toast.error(err.response?.data || 'Failed to fetch states');
        }
    };

    const getAllShift = async () => {
        await ClientService.getAllShifts().then(res => {
            if (res.status === 200) {
                setShifts(res.data.shifts.map((data: any) => {
                    return {
                        label: data.shiftName + " - " + moment(data.startTime).format("DD MMM YYYY"),
                        value: data._id,
                        startTime: data.startTime,
                        endTime: data.endTime,
                        biometricStartTime: data.biometricStartTime,
                        biometricEndTime: data.biometriEndTime
                    }
                }))
            }
        }).catch(err => {
            toast.error(err.response.data);
        })
    }

    useEffect(() => {
        getAllShift();
    }, [])

    useEffect(() => {
        if (selectedValue) {
            getUniqueCity();
            getUniqueState();
        }
    }, [selectedValue]);

    useEffect(() => {
        if (csrStatsRef.current) {
            csrStatsRef.current.getCountData();
        }
        // if (verificationDataRef.current) {
        //     verificationDataRef.current.getDataForGraphs();
        // }
        // if (stateStatsRef.current) {
        //     stateStatsRef.current.fetchData();
        // }
    }, [selectedFilters]);


    return (
        <>
            <Row className="mt-5 text-left">
                <Col md={8}>
                    <h4 style={{ color: colors.primary.main, fontWeight: 700, marginTop: '0.75rem' }}>Dashboard</h4>
                </Col>
                <Col md={4}>
                    <div style={{
                        ...colorSchemes.cardDark,
                        borderRadius: '0.75rem',
                        padding: '1rem',
                    }}>
                        <Form.Label style={{ color: colors.text.secondary, fontWeight: 600, marginBottom: '0.5rem', display: 'block' }}>
                            Select Shift
                        </Form.Label>
                        <Select
                            options={shifts}
                            placeholder="Select Shifts"
                            onChange={(e: any) => setSelectedValue(e?.value)}
                            isClearable
                            value={selectedValue ? shifts.find((shift: any) => shift.value === selectedValue.value) : null}
                            styles={{
                                control: (base, state) => {
                                    const rgbColor = colors.primary.main.replace('#', '');
                                    const r = parseInt(rgbColor.substring(0, 2), 16);
                                    const g = parseInt(rgbColor.substring(2, 4), 16);
                                    const b = parseInt(rgbColor.substring(4, 6), 16);
                                    return {
                                        ...base,
                                        borderColor: state.isFocused ? colors.primary.main : colors.border.secondary,
                                        backgroundColor: colors.background.primary,
                                        boxShadow: state.isFocused ? `0 0 0 3px rgba(${r}, ${g}, ${b}, 0.1)` : 'none',
                                        borderRadius: '0.5rem',
                                        minHeight: '44px',
                                        transition: 'all 0.3s ease',
                                        '&:hover': { borderColor: colors.primary.main }
                                    };
                                },
                                input: (base) => ({
                                    ...base,
                                    color: colors.text.primary
                                }),
                                placeholder: (base) => ({
                                    ...base,
                                    color: colors.text.muted
                                }),
                                singleValue: (base) => ({
                                    ...base,
                                    color: colors.text.primary,
                                    fontWeight: 500
                                }),
                                option: (base, state) => ({
                                    ...base,
                                    backgroundColor: state.isSelected ? colors.primary.main : state.isFocused ? colors.background.secondary : colors.background.primary,
                                    color: state.isSelected ? colors.background.primary : colors.text.primary,
                                    padding: '0.75rem 1rem',
                                    fontWeight: state.isSelected ? 600 : 500,
                                    transition: 'all 0.2s ease'
                                }),
                                menuList: (base) => ({
                                    ...base,
                                    paddingTop: 0,
                                    paddingBottom: 0
                                }),
                                menu: (base) => ({
                                    ...base,
                                    backgroundColor: colors.background.primary,
                                    border: `1px solid ${colors.border.secondary}`,
                                    boxShadow: '0 4px 16px rgba(0, 0, 0, 0.1)',
                                    borderRadius: '0.75rem',
                                    marginTop: '0.5rem'
                                })
                            }}
                        />
                    </div>
                </Col>
            </Row>
            {!selectedValue ?
                <p style={{ color: colors.text.light, fontWeight: 600, textAlign: 'center', marginTop: '1rem' }}>Please select shift first...</p>
                :
                <>

                    <FiltersComponent
                        selectedShift={selectedValue}
                        onFiltersChange={handleFiltersChange}
                        showExamFilters={true}
                    />


                    <div className="mt-3 mb-3">
                        <CsrStatsIndex
                            ref={csrStatsRef}
                            shift={selectedValue}
                            selectedCenters={selectedFilters?.centers}
                            selectedZones={selectedFilters?.zones}
                            selectedDistrict={selectedFilters?.districts}
                            selectedStates={selectedFilters?.states}
                            states={states}
                            cities={districts}
                            selectedCourses={selectedFilters?.courses}
                        />
                    </div>

                    <div className="mt-3">
                        {/* <VerificationTrends
                            shiftId={selectedValue}
                            selectedStates={selectedStates}
                            selectedDistrict={selectedDistricts}
                            selectedZones={selectedZones}
                            selectedCenters={selectedCenters}
                            defaultEndTime={shifts?.find((shift: any) => shift.value === selectedValue)?.biometricEndTime}
                            defaultStartTime={shifts?.find((shift: any) => shift.value === selectedValue)?.biometricStartTime}
                            selectedCourses={selectedCourses}
                        /> */}
                        {/* <VerifiedStats
                            ref={verificationDataRef}
                            shiftId={selectedValue}
                            selectedCenters={selectedFilters?.centers}
                            selectedZones={selectedFilters?.zones}
                            selectedDistrict={selectedFilters?.districts}
                            selectedStates={selectedFilters?.states}
                            states={states}
                            cities={districts}
                            selectedCourses={selectedFilters?.courses}
                        />

                        <div>
                            <StateStats
                                ref={stateStatsRef}
                                shiftId={selectedValue}
                                cities={districts}
                            />
                        </div> */}
                    </div>
                </>
            }
        </>
    )
}
